const config = {};

//只有.env.配置 中VUE_APP_* 的有效
// this.$log(process.env);

config.app_id = 'wx441c534516758ef0';
config.app_secret = 'db330f7a282f73595bccdd448612f8bd';
config.env = process.env.NODE_ENV;
config.title = process.env.VUE_APP_TITLE;
config.project = process.env.VUE_APP_ENV;

switch (config.project) {
    case 'hm':
        config.redirect_url = "https%3A%2F%2Fhm.wapg.cn%2Fhema%2F%23%2Fmy";
        break;
    case 'jd':
        config.redirect_url = "http%3A%2F%2Fjd.wapg.cn%2F%23%2Fmy";
}

export default config;